// extracted by mini-css-extract-plugin
export default {"standAloneButtonsContainer":"StandAloneButtons__standAloneButtonsContainer___JFn65","standAloneButtonContainer":"StandAloneButtons__standAloneButtonContainer___YDVdN"};